import React from "react"
import PropTypes from "prop-types"
import { Navigate } from "react-router-dom"
import { isProApp } from "utils/app-type"
import { routes } from "router"

const GuestOnly = ({ children, redirectTo }) => {
  // If we are on the Pro (guide) app host, do not render guest-only pages
  if (isProApp()) {
    return <Navigate to={redirectTo || routes.signInV2()} replace />
  }
  return children
}

GuestOnly.propTypes = {
  children: PropTypes.node,
  redirectTo: PropTypes.string
}

export default GuestOnly
